import {
  textBody1,
}
  from '_utils/styles/';


export default {
  descriptionSize: textBody1
};
